$ = jQuery;

$(document).ready(function () {
  var page = 1;
  console.log(admin.count_web_stories);

  $('.nav-link').on('click', function (e) {
    e.preventDefault();
    categorySelected = $(this);
    skeleton = $('#skeleton-ws');
    stories = $('#web-stories');

    $.ajax({
      url: admin.url,
      type: 'POST',
      data:{
        'action': 'jc_ajax_get_web_stories',
        'category': categorySelected.attr('id')
      },
      beforeSend: function () {
        skeleton.removeClass('d-none');
        skeleton.addClass('d-block');
        stories.removeClass('d-block');
        stories.addClass('d-none');
      },
      success: function(response) {
        if(response.data.length) {
          page = 1;
          skeleton.removeClass('d-block');
          skeleton.addClass('d-none');
          stories.removeClass('d-none');
          stories.addClass('d-block');

          $('a').removeClass('active');
          categorySelected.addClass('active');
          $('#web-stories').html(response.data);
          setPaginationButton(page, $('.nav-link.active').text())
        }
      },

    });
  });

  $(document).on('click', '.page-nav', function (e) {
    e.preventDefault();
    pageSelected = $(this);
    skeleton = $('#skeleton-ws');
    stories = $('#web-stories');
    category = $('.nav-link.active');

    $.ajax({
      url: admin.url,
      type: 'POST',
      data:{
        'action': 'jc_ajax_get_web_stories',
        'category': category.attr('id') ? category.attr('id') : null,
        'page': getPage(pageSelected,page, $('.nav-link.active').text())
      },
      beforeSend: function () {
        skeleton.removeClass('d-none');
        skeleton.addClass('d-block');
        stories.removeClass('d-block');
        stories.addClass('d-none');
      },

      success: function(response) {
        if(response.data.length) {
          page = getPage(pageSelected,page, $('.nav-link.active').text())
          setPaginationButton(page, $('.nav-link.active').text())

          skeleton.removeClass('d-block');
          skeleton.addClass('d-none');
          stories.removeClass('d-none');
          stories.addClass('d-block');

          $('#web-stories').html(response.data);
        }
      }

    });
  });


  function setPaginationButton(page, category){
    var content = '<ul class="pagination justify-content-center">';

    if(page > 1){
      if(page * admin.limit >= admin.count_web_stories[category]){
        content +=
          '<li class="page-item"><span data-pagination="first" class="border-button page-link page-nav screen-reader-text"> << </span></li>' +
          '<li class="page-item"><span data-pagination="previous" class="border-button page-link page-nav screen-reader-text">' + (page-1) +
          '</span></li><li class="page-item active"><span data-pagination="current" class="border-button page-link current-page">'+ page +'</span></li>';
      }
      else{
        content +=
          '<li class="page-item"><span data-pagination="first" class="border-button page-link page-nav screen-reader-text"> << </span></li>' +
          '<li class="page-item"><span data-pagination="previous" class="border-button page-link page-nav screen-reader-text">' + (page-1) +
          '</span></li><li class="page-item active"><span data-pagination="current" class="border-button page-link current-page">'+ page +'</span></li>' +
          '<li class="page-item"><span data-pagination="next" class="border-button page-link page-nav screen-reader-text">' + (page+1) +
          '</span></li><li class="page-item"><span data-pagination="last" class="border-button page-link page-nav screen-reader-text"> >> </span></li>' ;
      }
    }
    else
    {
      if(page * admin.limit >= admin.count_web_stories[category]){
        content += '<li class="page-item active"><span data-pagination="current" class="border-button page-link current-page">'+ page +'</span></li>';
      }
      else{
        content +=
          '<li class="page-item active"><span data-pagination="current" class="border-button page-link current-page">'+ page +'</span></li>' +
          '<li class="page-item"><span data-pagination="next" class="border-button page-link page-nav screen-reader-text">' + (page+1) +
          '</span></li><li class="page-item"><span data-pagination="last" class="border-button page-link page-nav screen-reader-text"> >> </span></li>';
      }
    }
    content += '</ul>';
    $('.pagination').replaceWith(content);
  }

  function getPage(pageSelected, page, category){
    switch (pageSelected.data("pagination")) {
      case 'first': return 1;
      case 'previous': return page-1;
      case 'next': return page+1;
      case 'last': return Math.ceil(admin.count_web_stories[category] / admin.limit);
      default: return page;
    }
  }
});

